import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  hideMessage?: boolean; // New prop
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading…',
  size = 'md',
  fullScreen = false,
  hideMessage = false, // Default to false
}) => {
  const sizeClasses = {
    sm: 'h-5 w-5',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const containerClasses = fullScreen
    ? 'p-4 sm:p-6 bg-gray-50 min-h-screen flex items-center justify-center'
    : 'flex items-center justify-center'; // Removed py-8

  return (
    <div className={containerClasses}>
      <div className="flex items-center space-x-3">
        <svg
          className={`animate-spin ${sizeClasses[size]} text-primary-500`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        {!hideMessage && (
          <span className={`text-gray-600 ${size === 'lg' ? 'text-xl' : 'text-lg'}`}>
            {message}
          </span>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
